/**
 * Tawk.to Live Chat Widget Component — TEMPORARILY DISABLED (2026-06-05)
 *
 * The previous implementation loaded `https://embed.tawk.to/<propertyId>/default`
 * using a placeholder property ID (`5f8e8e8e8e8e8e8e8e8e8e8e`) that returns
 * HTTP 404 in production. A 404-ing third-party script that fires on every
 * route was flagged by the production audit at
 * /app/audit/PRODUCTION_AUDIT_REPORT.md as a contributor to the Google Ads
 * "Compromised Site" disapproval.
 *
 * To re-enable:
 *   1. Sign up for a real Tawk.to property at https://dashboard.tawk.to/signup
 *   2. Add REACT_APP_TAWK_PROPERTY_ID (and optionally REACT_APP_TAWK_WIDGET_ID)
 *      to frontend/.env
 *   3. Replace this stub with a real loader that injects the script only when
 *      both env vars are present and non-empty.
 */
const TawkWidget = () => null;

export default TawkWidget;
